export const TADARIDA_USER_PERSIST_KEY = 'tadarida-user-v1';
export const TADARIDA_SESSION_PERSIST_KEY = 'tadarida-session-v1';
export const TADARIDA_LOGOUT_BROADCAST_KEY = 'tadarida-logout-broadcast';

export const EXPIRY_6_MONTHS_IN_DAYS = 6 * 30;
